import React, { useState } from "react";
//import { Link, useNavigate } from "react-router-dom";
import {  useNavigate } from "react-router-dom";
import "./Login.css";
import { loginProfile } from "../lib/profileApi";

export default function LoginPage() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const [contact, setContact] = useState("");
  const [password, setPassword] = useState("");
  const [statusMessage, setStatusMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatusMessage("");

    try {
      const profile = await loginProfile(contact, password);
      localStorage.setItem("authenticatedProfileId", profile.id);
      navigate("/");
    } catch (error) {
      setStatusMessage(error.message);
    }
  };

  return (
    <div className="l-container">
      <form className="card" onSubmit={handleSubmit}>
        <h2 className="title">Welcome</h2>

        <div className="input-group">
          <span className="icon">👤</span>
          <input
            type="text"
            placeholder="E-mail"
            className="input"
            value={contact}
            onChange={(event) => setContact(event.target.value)}
          />
        </div>

        <div className="input-group">
          <span className="icon">🔒</span>
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            className="input"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
          <span
            className="toggle"
            onClick={() => setShowPassword(!showPassword)}
          >
            👁️
          </span>
        </div>

        <div className="options">
          <div className="remember">
            <label>Remember Me</label>
            <input
              type="checkbox"
              checked={remember}
              onChange={() => setRemember(!remember)}
            />
          </div>
          {/* <a href="#jj" className="forgot">
            Forgotten Password?
          </a> */}
        </div>
        {statusMessage ? <p className="login-status">{statusMessage}</p> : null}
       
         <button className="login-btn" type="submit">Login</button>
  
       


       

        <div className="divider"></div>

        {/* <div className="new-user">
          <h3>New User?</h3>
          <p>
            
          </p>
          <Link  to="/auth">
          <button className="create-btn">Create Account</button>
          </Link>

          
        </div> */}
      </form>
    </div>
  );
}
